
let defaultState = {
        inputs: {},
        computed: {},
        currStep: 1
}



let formFlow = (state = defaultState, action) => {

    switch (action.type) {

        case 'UPDATE_FORM_FLOW_INPUTS':
            return {
                ...state,
                inputs: {
                    ...state.inputs,
                    ...action.data
                }
            }

        case 'UPDATE_FORM_FLOW_COMPUTED':
            return {
                ...state,
                computed: {
                    ...state.computed,
                    ...action.data
                }
            }


        case 'CLEAR_FORM_FLOW':
            return {
                ...defaultState
            }

        case 'SET_FORM_FLOW_CURR_STEP':
            return {
                ...state,
                currStep: action.data,
            }

        default:
            return state

    }
}


export default formFlow;
